import { Loading, Typography } from "@cpj-ai/panel-npm-package";
import { AuthAccountJobPositionAssignmentStatusChoices, useGetJobPositionAssignmentsQuery } from "@graphql/generated";
import JobCard from "@modules/JobSuggestion/components/JobCard";

const NewJobsPositionsTabContent = () => {
  const status = AuthAccountJobPositionAssignmentStatusChoices.AWAITING_JOBSEEKER_APPROVAL;
  const { data, loading } = useGetJobPositionAssignmentsQuery({ variables: { jobSeekerStatus: status } });

  const jobPositions = data?.me?.jobPositionAssignments?.edges;

  if (loading) return <Loading />;

  return (
    <div className="flex flex-col gap-4 h-4/6 overflow-auto">
      {jobPositions?.length && jobPositions?.length > 0 ? (
        jobPositions?.map((job, index) => <JobCard key={index} jobPosition={job?.node} />)
      ) : (
        <Typography variant="muted" className="text-center py-32">
          There is no job suggestion
        </Typography>
      )}
    </div>
  );
};

export default NewJobsPositionsTabContent;
